import { MWEB_SOURCE, WEB_SOURCE, WINDOWSAPP_SOURCE, COMPUTERAPP_SOURCE, WINDOWS_COMPUTERAPP_SOURCE, LINUX_COMPUTERAPP_SOURCE, XPLAT_MACOS_COMPUTERAPP_SOURCE, } from '#pplx/frontend/fetcher/constants.js';
export const getApiClient = ({ isMobile, isWindowsApp, isLinuxOS = false, isMacOS = false, }) => {
    if (import.meta.env.VITE_IS_COMPUTER_APP_BUILD)
        return COMPUTERAPP_SOURCE;
    if (import.meta.env.VITE_IS_PERPLEXITY_DESKTOP_BUILD) {
        if (isMacOS)
            return XPLAT_MACOS_COMPUTERAPP_SOURCE;
        return isLinuxOS ? LINUX_COMPUTERAPP_SOURCE : WINDOWS_COMPUTERAPP_SOURCE;
    }
    if (isWindowsApp)
        return WINDOWSAPP_SOURCE;
    if (isMobile)
        return MWEB_SOURCE;
    return WEB_SOURCE;
};
//# sourceMappingURL=utils.js.map